module.exports = __webpack_public_path__ + "img/skills.e79fb5da.png";